const JSON_HEADERS = { "Content-Type": "application/json", Accept: "application/json" }

export function scenarioRequestDataFromFormData(formData, pagePath = currentPagePath()) {
  return {
    scene: clean(formData.get("scene")) || "未选择卡点类型",
    problem: clean(formData.get("problem")),
    assets: clean(formData.get("assets")),
    company: clean(formData.get("company")),
    industry: clean(formData.get("industry")),
    timeline: clean(formData.get("timeline")),
    contact: clean(formData.get("contact")),
    page_path: pagePath,
  }
}

export async function createScenarioRequest(request, fetcher = fetch) {
  const response = await fetcher(sameOriginPath("/api/scenario_requests"), {
    method: "POST",
    headers: JSON_HEADERS,
    body: JSON.stringify(request),
  })

  return readDataResponse(response)
}

export async function fetchScenarioRequests(fetcher = fetch) {
  return readListResponse(await fetcher(sameOriginPath("/admin/api/scenario_requests"), { headers: { Accept: "application/json" } }))
}

export async function fetchScenarioRequest(id, fetcher = fetch) {
  return readDataResponse(await fetcher(sameOriginPath(`/admin/api/scenario_requests/${id}`), { headers: { Accept: "application/json" } }))
}

async function readDataResponse(response) {
  const payload = await readPayload(response)
  if (!response.ok) throw new Error(payload.error || "需求场景请求处理失败，请稍后再试。")

  return payload.data
}

async function readListResponse(response) {
  const payload = await readPayload(response)
  if (!response.ok) throw new Error(payload.error || "需求场景列表读取失败，请稍后再试。")

  return { data: payload.data || [], meta: payload.meta || {} }
}

async function readPayload(response) {
  try {
    return await response.json()
  } catch {
    return {}
  }
}

function currentPagePath() {
  if (!globalThis.window) return ""
  return `${window.location.pathname}${window.location.hash}`
}

function sameOriginPath(path) {
  if (!globalThis.window) return path
  return new URL(path, window.location.origin).toString()
}

function clean(value) {
  return value?.toString().trim() || ""
}
